import React, { useMemo } from 'react';

import MemberResultContentPC from './MemberResultContentPC';
import MemberResultContentSP from './MemberResultContentSP';
import { buildMemberResultViewModel } from './common/resultViewModel';

const RESPONSIVE_MODE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

function MemberResultContent({ responsiveMode, user, dialogDatas, resultFetchState }) {
  const viewModel = useMemo(
    () => buildMemberResultViewModel({ user, dialogDatas, resultFetchState }),
    [dialogDatas, resultFetchState, user]
  );
  const contentProps = {
    dialogDatas,
    viewModel,
  };

  if (responsiveMode === RESPONSIVE_MODE.MOBILE) {
    return <MemberResultContentSP {...contentProps} />;
  }

  return <MemberResultContentPC {...contentProps} />;
}

export default MemberResultContent;
